export const hideAsync = () => Promise.resolve()
export const preventAutoHideAsync = () => Promise.resolve()
export const hide = () => {}

export default {
  hideAsync,
  preventAutoHideAsync,
  hide,
}
